var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutocad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.983 3.33337H13.033C6.94969 3.33337 3.33301 6.95004 3.33301 13.0167V26.9667C3.33301 33.0334 6.94967 36.65 13.0163 36.65H26.9663C33.033 36.65 36.6497 33.0334 36.6497 26.9667V13.0167C36.6663 6.95004 33.0497 3.33337 26.983 3.33337Z",
    fill: "#7D8FA5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3282_10901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5736 9.02033C22.4766 8.92334 22.2826 8.43835 21.6026 8.43835H14.8988C14.8988 8.43835 15.8698 8.53535 16.2588 9.50635C16.2588 9.50635 17.3278 12.0333 18.2987 14.4622C21.1166 21.069 25.4885 31.5612 25.4885 31.5612H31.9993C32.0963 31.4642 22.6726 9.11815 22.5746 9.02115L22.5736 9.02033ZM13.7329 9.8953L8.3891 22.5263C8.09711 23.4013 8.2911 24.4702 9.8461 24.4702H14.024L17.7159 15.6285C16.5499 12.7136 15.58 10.3807 15.58 10.3807C15.483 10.0887 15.191 9.3117 14.608 9.3117C14.025 9.3117 13.831 9.79768 13.7341 9.89468L13.7329 9.8953ZM13.6349 25.5383H9.166C8.38902 25.5383 8 25.0523 8 25.0523C8.77698 26.4123 11.0119 30.6881 11.0119 30.6881C11.4009 31.1741 11.7889 31.4651 12.3719 31.4651C13.6349 31.4651 15.5788 30.2021 15.5788 30.2021L23.0596 25.5382L13.6349 25.5383Z",
    fill: "#7D8FA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3282_10901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocad);
export default __webpack_public_path__ + "static/media/autocad.3e13a25fdfa0d74ae39328a5dc849aa2.svg";
export { ForwardRef as ReactComponent };